import React from 'react';
import Carousel, {CarouselItem} from '@components/common/carousel/carousel';
import Testimonial from "@components/common/testimonial/testimonial";
import './testimonial.scss'
import CedricD from '@images/homepage/testimonialSection/cedric-d.webp'
import Marek from '@images/homepage/testimonialSection/marek.webp'
import User from '@images/icons/avatar-user.svg'
import Kristin from '@images/homepage/testimonialSection/kristin.webp'
import Stars from '@images/homepage/testimonialSection/stars.svg'

function TestimonialSection() {

  const testimonials = [
    {
      'name': 'Cédric D.',
      'icon': CedricD,
      'className': 'one',
      'testimonial': 'The simplicity! No more endless back and forth emails to schedule meetings and events. With Trafft, you can do it all in one business management software, on your own terms. Accept unlimited bookings, manage staff schedules, take payments with customers, all within one business management tool and it\'s very flexible. We love it.',
      'stars': Stars
    },
    {
      'name': 'Marek K.',
      'icon': Marek,
      'className': 'one',
      'testimonial': 'Ease of use. Stellar customer support. Integrates with your Google Calendar. Automatic reminders. It\'s got everything you might need in a booking software. It’s the best appointment scheduling software.',
      'stars': Stars
    },
    {
      'name': 'Burak D.',
      'icon': User,
      'className': 'two',
      'testimonial': 'If you want to manage appointments in your company, you can\'t and shouldn\'t avoid this appointment schedule software. The simple and intuitive user interface and the management of multiple users is what puts Trafft ahead of the competition. It\'s really easy to use and very customizable. And then on top of that, the price, simply unbeatable!',
      'stars': Stars
    },
    {
      'name': 'Marvin F.',
      'icon': User,
      'className': 'three',
      'testimonial': 'It was a sign of relief! I was with another appointment scheduling software last time before I switched and it was a headache both the price and the workaround. With Trafft, all I just do is copy and send, and voila- customers pay!',
      'stars': Stars
    },
    {
      'name': 'Kristin K.',
      'icon': Kristin,
      'className': 'four',
      'testimonial': 'I love the ease of use and how easy it is for potential/clients to book sessions. The booking software interface is clean and appealing. It is easy to use and accept bookings and has great scheduling features like automated emails, multiple services, group scheduling and easy set-up payment. It’s one of the best business tools.',
      'stars': Stars
    },
  ];

  return (
    <div className='homepage-st-wrapper'>
      <div className='homepage-st-wrapper__single-testimonial'>
        <Carousel>
          {testimonials.map((testimonial) =>
            <CarouselItem key={testimonial.name}>
              <Testimonial
                type='single'
                description={testimonial.testimonial}
                icon={testimonial.icon}
                name={testimonial.name}
                image={testimonial.stars}
              >
              </Testimonial>
            </CarouselItem>
          )}
        </Carousel>
      </div>
    </div>
  )
}

export default TestimonialSection